import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { DialogModule } from 'primeng/dialog';
import { MessagesModule } from 'primeng/messages';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { DirectivesModule } from '../core/directives/directives.module';
import { SharedModule } from '../shared/shared.module';
import { PharmAuthorizationComponent } from './pharm-authorization.component';
import { PharmAuthorizationRoutingModule } from './pharm-authorization-routing.module';
import { CheckboxModule } from 'primeng/checkbox';
import { PharmOrderSubmissionLoadingOverlayComponent } from './order-submission-loading-overlay/order-submission-loading-overlay.component';
import { BlockUIModule } from 'primeng/blockui';

@NgModule({
  declarations: [PharmAuthorizationComponent, PharmOrderSubmissionLoadingOverlayComponent],
  imports: [
    ButtonModule,
    CardModule,
    CommonModule,
    PharmAuthorizationRoutingModule,
    DialogModule,
    DirectivesModule,
    MessagesModule,
    SharedModule,
    TableModule,
    TagModule,
    TooltipModule,
    CheckboxModule,
    BlockUIModule,
  ],
})
export class PharmAuthorizationModule {}
